import { motion } from 'motion/react'
import { CardActionsMenu } from './CardActionsMenu'
import { Link } from 'react-router'
import {
  // CardTitle,
  // CardDescription,
  CardAction,
  CardContent,
  Card,
  CardFooter,
  // CardHeader,
} from '@/components/shadcn/card'
import { presenceAnimation } from '@/components/ui/NoSeachResultsDisplay'
import { MessagesWorkspacesWorkspaceCard } from './WorkspacesGrid'
import { ENDPOINTS } from '@/util/endpoints'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconInformationOutline } from '@icons/IconInformationOutline'
import { getAppLaunchPath } from '@/util/getAppLaunchPath'
import { cn } from '@/lib/utils'
import { IconBg } from '@/components/ui/IconBg'
import { ApplicationIcon, OrganisationIcon, ProjectIcon } from '@/const'
import { useSessionStorage } from '@/hooks'
import { isApplicationAdmin, isPlatformAdmin, isProjectAdmin, isProjectLeader, isSuperUser } from '@/util'

export function WorkspacesGridItem({
  workspace,
  className,
}: {
  workspace: MessagesWorkspacesWorkspaceCard
  className?: string
}) {
  const [roles] = useSessionStorage('roles', 0)
  const {
    card,
    project,
    organisation,
    application,
    app_types,
    app_key,
    app_id,
    project_id,
    workspaceId,
    organisation_id,
  } = workspace
  const { image, subtitle } = card

  const launchAppPath = getAppLaunchPath(app_types, app_key, app_id, project_id, workspaceId, organisation_id)
  // const workspaceDetailsPath = `/workspace?orgId=${organisation_id}&orgName=${organisation}&subscriptionId=${workspaceId}&tab=details&appKey=${app_key}&appName=${application}&projectId=${project_id}&projectName=${project}`
  const workspaceDetailsPath = `/workspaces/${workspaceId}`

  const canEditWorkspace =
    isProjectAdmin(roles) ||
    isProjectLeader(roles) ||
    isSuperUser(roles) ||
    isApplicationAdmin(roles) ||
    isPlatformAdmin(roles)

  return (
    <motion.div
      className={cn('relative overflow-visible', className)}
      layout
      key={workspace.workspaceId}
      {...presenceAnimation}
    >
      {canEditWorkspace && (
        <CardAction className="absolute right-2 top-2">
          <CardActionsMenu launchAppPath={launchAppPath} workspaceDetailsPath={workspaceDetailsPath} />
        </CardAction>
      )}
      <Link
        // className="group block h-full overflow-visible rounded-xl bg-background shadow transition-all dark:border dark:hover:border-secondary"
        className="group block h-full overflow-visible bg-background shadow transition-all dark:border dark:hover:border-secondary"
        to={launchAppPath}
      >
        <div className="grid h-full grid-cols-[100px_1fr]">
          <div
            // className="justify-between rounded-l-xl bg-muted bg-cover bg-center"
            className="justify-between bg-muted bg-cover bg-center"
            style={{ backgroundImage: `url(${ENDPOINTS.DOTNET}/rest/support/getImage?imageKey=${image})` }}
          />
          {/* <Card className="h-full justify-between overflow-hidden rounded-l-none border-none bg-background py-0 shadow-none group-hover:bg-secondary"> */}
          <Card className="h-full justify-between overflow-hidden border-none bg-background py-0 shadow-none group-hover:bg-secondary">
            <CardContent className="flex flex-col justify-center gap-y-3 pt-6">
              <div className="flex items-center gap-3">
                <IconBg tooltip="Project" className="group-hover:border">
                  <ProjectIcon className="size-6" />
                </IconBg>
                <p className="text-base font-medium leading-tight">{project}</p>
              </div>
              <div className="flex items-center gap-3">
                <IconBg tooltip="Organisation" className="group-hover:border">
                  <OrganisationIcon className="size-6 text-muted-foreground" />
                </IconBg>
                <p className="font-light leading-tight">{organisation}</p>
              </div>
            </CardContent>
            <CardFooter className="flex-1 bg-muted py-3 group-hover:bg-secondary">
              <div className="flex items-center gap-3">
                <IconBg tooltip="Application" className="border bg-background">
                  <ApplicationIcon className="size-6 text-muted-foreground" />
                </IconBg>
                <p className="font-light leading-tight">{application}</p>
                <TooltipButton tooltip={subtitle}>
                  <div className="shrink-0 rounded-full bg-background">
                    <IconInformationOutline className="h-4 w-4 text-muted-foreground" />
                  </div>
                </TooltipButton>
              </div>
            </CardFooter>
          </Card>
        </div>
      </Link>
    </motion.div>
  )
}
